/*
 * Copyright 2024 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.di

import org.koin.core.module.Module
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module
import studio.oddpods.cauce.core.base.common.di.CommonModule
import studio.oddpods.cauce.core.data.repository.NetworkMonitor
import studio.oddpods.cauce.core.data.repository.UserDataRepository
import studio.oddpods.cauce.core.data.repository.UserLogoutManager
import studio.oddpods.cauce.core.data.repository.cauce.DashboardRepository
import studio.oddpods.cauce.core.data.repository.cauce.PatientRepository
import studio.oddpods.cauce.core.data.repository.cauce.PaymentRepository
import studio.oddpods.cauce.core.data.repository.cauce.ProfileRepository
import studio.oddpods.cauce.core.data.repository.cauce.RecurringScheduleRepository
import studio.oddpods.cauce.core.data.repository.cauce.ReminderRepository
import studio.oddpods.cauce.core.data.repository.cauce.SessionRepository
import studio.oddpods.cauce.core.data.repository.notification.NotificationSchedulingService
import studio.oddpods.cauce.core.data.repository.notification.NotificationSettingsRepository
import studio.oddpods.cauce.core.data.repositoryImpl.NetworkMonitorImpl
import studio.oddpods.cauce.core.data.repositoryImpl.UserDataRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.UserLogoutManagerImpl
import studio.oddpods.cauce.core.data.repositoryImpl.cauce.DashboardRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.cauce.PatientRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.cauce.PaymentRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.cauce.ProfileRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.cauce.RecurringScheduleRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.cauce.ReminderRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.cauce.SessionRepositoryImpl
import studio.oddpods.cauce.core.data.repositoryImpl.notification.NotificationSettingsRepositoryImpl
import studio.oddpods.cauce.core.datastore.di.DatastoreModule
import studio.oddpods.cauce.core.formatter.di.FormatterModule

val DataModule = module {
    includes(platformModule, CommonModule, DatastoreModule, FormatterModule)

    singleOf(::NetworkMonitorImpl) bind NetworkMonitor::class
    singleOf(::UserDataRepositoryImpl) bind UserDataRepository::class
    singleOf(::UserLogoutManagerImpl) bind UserLogoutManager::class

    singleOf(::PatientRepositoryImpl) bind PatientRepository::class
    singleOf(::SessionRepositoryImpl) bind SessionRepository::class
    singleOf(::RecurringScheduleRepositoryImpl) bind RecurringScheduleRepository::class
    singleOf(::PaymentRepositoryImpl) bind PaymentRepository::class
    singleOf(::DashboardRepositoryImpl) bind DashboardRepository::class
    singleOf(::ProfileRepositoryImpl) bind ProfileRepository::class
    singleOf(::ReminderRepositoryImpl) bind ReminderRepository::class

    singleOf(::NotificationSettingsRepositoryImpl) bind NotificationSettingsRepository::class
    singleOf(::NotificationSchedulingService)
}

expect val platformModule: Module
